import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { SnackBarService } from 'src/app/services/snackbar/snackBar.service';
import {
  ERROR,
  NotificationErrorAction,
  NotificationSuccessAction,
  RESET,
  SUCCESS,
} from '../actions/global-notification.action';

@Injectable()
export class GlobalNotificationEffects {
  constructor(
    private actions$: Actions,
    private snackBarService: SnackBarService,
  ) {}

  errorNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(ERROR),
        map((action: NotificationErrorAction) =>
          this.snackBarService.showWarningSnackBar(action.payload),
        ),
      );
    },
    { dispatch: false },
  );

  successNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(SUCCESS),
        map((action: NotificationSuccessAction) =>
          this.snackBarService.showSnackBar(action.payload),
        ),
      );
    },
    { dispatch: false },
  );

  resetNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(RESET),
        map(() => this.snackBarService.dismiss()),
      );
    },
    { dispatch: false },
  );
}
